import { useEffect, useMemo } from "react";
import styles from "./LessonLibrary.module.scss";

import { SllProgram, useGetProgramsLazyQuery } from "@src/api/graphql-codegen";
import ProgramOverview from "@src/components/program-overview/ProgramOverview";
import Spinner from "@src/components/spinner/Spinner";
import { sortByPosition } from "@src/utils/helpers";
import { AusStudentVoiceSeries } from "@src/utils/constants";

type Props = {
  isAUuser?: boolean;
}

function Programs(props: Props) {
  const { isAUuser } = props;
  const [getPrograms, { data, loading }] = useGetProgramsLazyQuery({
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    getPrograms();
  }, [getPrograms]);

  const programList = useMemo(() => {
    if (!data?.getPrograms) return [];
    return data.getPrograms.filter((program) => !!program.isShown).sort(sortByPosition);
  }, [data]);

  return (
    <div className={styles.mainView}>
      {loading ? <div className={styles.lazyLoadingView}><Spinner /></div> : 
      <div className={styles.libraryView}>
        <div className={styles.collectionContainer}>
          {isAUuser ? <ProgramOverview program={AusStudentVoiceSeries} isAusStudentVoiceSeries={true} /> : null}
          {programList.map((program) => (
            <ProgramOverview key={program.id} program={program as SllProgram} />
          ))}
        </div>
      </div>}
    </div>
  );
}

export default Programs;
